import $ from 'jquery';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Carousel } from 'react-responsive-carousel';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import '../../../node_modules/react-responsive-carousel/lib/styles/carousel.min.css';
import TextField from 'material-ui/TextField';
import * as actions from '../../actions/actions.jsx';
import services from '../../services/allservices.jsx';
import { withRouter, Link } from 'react-router-dom';

import creditcardlogo from '../../images/credit-cards-vector-icon-.jpg';
import Loader from '../loader/loader.jsx';
import LoaderSmall from "../loader/loadersmall.jsx";
import UserModal from './regmodal.jsx';
import RaisedButton from 'material-ui/RaisedButton';
import GusetNavbar from '../navigation/guestnavbar';
import InputMask from 'react-input-mask';
import android from '../../images/android.png';
import ios from '../../images/ios.png';
import logo from "../../images/KlickExLogo_w.png";
import highlitedtext from '../../images/highlitedau.png';

import activateImg from '../../images/iconShopping.svg';
import customerImg from '../../images/iconCustomersupport.svg';
import manageImg from '../../images/icoAccount.png';

import klickexcardNz from '../../images/klickexcardnz.png';
import klickexcardAu from '../../images/klickexcardau.png';
import flagNz from '../../images/ico_flagroundNZ.png';
import flagAu from '../../images/ico_flagroundAU.png';
import wowcard from '../../images/wowcard.png';

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};

const mapStateToProps = state =>
({
    publicKey: state.publicKey.publicKey,
    keyRecieved: state.publicKey.keyRecieved,
    activationcardState: state.getactivationcardReducer.activationcardState
})
const mapDispatchToProps = dispatch =>
({
    fetchPublicKey(keyRecieved) {
        dispatch(
            actions.publicKeyAction(keyRecieved)
        )
    },
    storeCardNumber(cardNumber) {
        dispatch(
            actions.storeCardDetail(cardNumber)
        )
    },
    getactivation(state) {

        dispatch(
            actions.getactivationcardAction(state)

        )
    },
})





const JSEncrypt = window.JSEncrypt
class Landing extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showModal : false,
            cardVerificationDone: false,
            mobileVerificationDone: false,
            mobiledisable: true,
            disabled: true,
            expiryDone: false,
            cardVerified: false,
            verification: false,
            rederFeedback: false,
            mobilecardVerified: false,
            mobileverification: false,
            mobilerederFeedback: false,
            mobile: '',
            open: false,
            loader: false,
            title: "Invalid Card Number",
            openModal: false,
            cardType: "",
            emailId : "",
            width: props.innerWidth,
            height: props.innerHeight,
            rndInt: 0
        };
        this.storeCard = this.storeCard.bind(this)
        this.updateWindowDimentions = this.updateWindowDimentions.bind(this);
    }
    componentWillMount(){
                localStorage.removeItem('pform')
    }
    componentDidMount() {
        this.props.fetchPublicKey(false)
        this.updateWindowDimentions();
        window.addEventListener('resize', this.updateWindowDimentions);
        // localStorage.setItem('landingTabs', 'cardNo')

        // document.getElementById("cardNumber").focus()
        this.setState({rndInt : this.randomIntFromInterval(1, 3)},()=>{
            console.log(this.state.rndInt)
        })
    }

    navigateURL=(platform)=>{
        if(platform === 'AU'){
            localStorage.setItem('pform', 'AU')
            // localStorage.setItem('platformURL', 'https://klickexmoneycard.com/klickexaucardservices/api/')
            //this.props.fetchPublicKey(false)
            window.location.href = 'https://cardholdertestenv01.oxygen-global.com/#/au'
            // window.location.href = 'https://klickexmoneycard.com/#/au'
            // window.location.href = 'http://localhost:3000/#/au'
            
        }else{
            localStorage.setItem('pform', 'NZ')
            //this.props.fetchPublicKey(false)
            // localStorage.setItem('platformURL', 'https://klickexmoneycard.com/cardservices/api/')
            window.location.href = 'https://cardholdertestenv01.oxygen-global.com/#/nz'
            // window.location.href ='https://klickexmoneycard.com/#/nz'
            // window.location.href ='http://localhost:3000/#/nz'
        }
        // "https://klickexmoneycard.com/#/au"
    }

    componentWillUnmount(){
        window.removeEventListener('resize', this.updateWindowDimentions);
    }
    
    randomIntFromInterval = (min, max) =>{ // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }


    updateWindowDimentions(){
        this.setState({
                width: window.innerWidth + 'px',
                height : (window.innerHeight - 120) + 'px'
        })
        console.log("Size :" , `${this.state.width} x ${this.state.height} `)
    }
    handleClose = () => {

        document.getElementById("myModal").style.display = "none"

    }

    onSuggestSelect(suggest) {

    }
    changeToEditView(e) {
        this.setState({ addressComp: false })
    }
    handleBlur() {
        this.setState({ addressComp: true })
    }
    handleDate(e, date) {
        this.setState({
            dateofbirth: date.toString()
        })
    }
    handleSelect(event, index, value) {
        this.setState({
            gender: value
        })
    }
    onChange(e, value) {
        this.setState({
            [e.target.name]: value
        })

    }
    handleClick = () => {
        localStorage.setItem('landingTabs', 'userName1')
        this.setState({
            landingTabs: 'userName1'
        })
    }
    handleRegister = () => {
        localStorage.setItem('landingTabs', 'cardNo')
        this.setState({
            landingTabs: 'cardNo'
        })
    }
    componentWillReceiveProps(nextProps) {
        // if (nextProps.managestate === true) {
        //     let lo = document.getElementById("signin")
        //     lo.classList.add("active")

        //     let lo1 = document.getElementById("signin1")
        //     lo1.classList.add("active")

        //     let cd = document.getElementById("cardno")
        //     cd.classList.remove("active")

        //     let cd1 = document.getElementById("cardno1")
        //     cd1.classList.remove("active")
        // }

        // else {
        //     let lo = document.getElementById("signin")
        //     lo.classList.remove("active")

        //     let lo1 = document.getElementById("signin1")
        //     lo1.classList.remove("active")

        //     let cd = document.getElementById("cardno")
        //     cd.classList.add("active")

        //     let cd1 = document.getElementById("cardno1")
        //     cd1.classList.add("active")
        // }
    }
    onEnterPress = (e) => {
        if (e.keyCode === 13 && e.shiftKey === false) {
            e.preventDefault();
            this.handleLogin();
        }
    }

    handelvalidateusername = (e, value) => {
        if (e.target.name === "userName" && value.length !== 0) {
            $(function () {
                $('#uName').on('keypress', function (e) {

                    if (e.which === 32)
                        return false;
                });
            });
            // if ((e.target.value.length) >= 6) {
            this.setState({
                userName: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctUsername: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }

    handelvalidatepassword = (e, value) => {
        if (e.target.name === "password" && value.length !== 0) {
            // if ((e.target.value.length) >= 8) {
            this.setState({
                password: value
            }, () => {
                if (this.state.userName.length !== 0 && this.state.password.length !== 0) {
                    this.setState({
                        disabled: false
                    })
                } else {
                    this.setState({
                        disabled: true
                    })
                }
            })
            // }else {
            //     this.setState({
            //         correctPassword: false
            //     })
            // }
        } else {
            this.setState({
                disabled: true
            })
        }
    }
    storeCard() {
        // this.props.history.push('/activate-card')
        this.setState({
            disabled: false

        })

        if (this.state.cardType === "A") {
            this.setState({
                openModal: true
            })
        }
        else if (this.state.cardType === "G" || this.state.cardType === "R") {
            this.props.history.push('/activate-card')
        }
        else {
            this.setState({
                disabled: true
            })

            setTimeout(function () {
                window.location.reload(1);
            }, 3000);
        }

        if (this.state.cardType === "G" || this.state.cardType === "R") {
            JSON.stringify(localStorage.setItem('step', 0))
            this.props.history.push('/activate-card')
        }

    }
    handleOldUser = () => {
        this.setState({
            existingUser: "yes",
            stepIndex: 1,
        }, () => {
            JSON.stringify(localStorage.setItem('step', 1))
            localStorage.setItem('existingUser', 'yes')
            setTimeout(() => {
                this.props.history.push('/activate-card')
            }, 500)

        })
    }
    handleNewUser = () => {
        this.setState({
            existingUser: "no",
            stepIndex: 1,
        }, () => {
            JSON.stringify(localStorage.setItem('step', 1))
            localStorage.setItem('existingUser', 'no')
            setTimeout(() => {
                this.props.history.push('/activate-card')
            }, 500)
        })
    }

    checkMobileNumber(e) {

        if (this.state.verification === true && this.state.mobileverification === true) {


            this.setState({
                // disabled: false

            })
        }
        else {
            this.setState({
                disabled: true
            })
        }

        if (e.target.value.length >= 4) {

            this.setState({ mobilecardVerified: true, mobilerederFeedback: false, disabled: false, })
            if (e.target.value === this.state.dob) {

                this.setState({ mobilecardVerified: false, mobilerederFeedback: true, mobileverification: true, mobileVerificationDone: true, })
            } else {
                this.setState({ mobilecardVerified: false, mobilerederFeedback: true, mobileverification: false, disabled: true })
            }
        }
        else{
            this.setState({
                mobileverification: false,
            })
        }
    }
    handleModal(e) {
        if (e) { e.preventDefault() }
        this.setState({ open: !this.state.open })
    }

    closeUserModal = () => {
        this.setState({
            openModal: false
        })
    }
     
    onFieldChange = (e, value) => {
        this.setState({
            email: value
        },()=>{
            console.log(this.state.email)
        })

    }

    toggleModal = () => this.setState({
        showModal: !this.state.showModal
      })


    render() {
        const { cardVerified, loader, verification, rederFeedback, mobilecardVerified, mobileverification, mobilerederFeedback } = this.state
        console.log("Height in here " , this.state.height)
        console.log("Email " , this.state.emailId)
        return (
            <div  className="" >
                
                {/* <GusetNavbar /> */}
                <div className="" style={{  backgroundColor: 'transparent' }}>
                    {this.state.openModal && <UserModal
                        open={this.state.openModal}
                        onClose={this.closeUserModal}
                        handleOld={this.handleOldUser}
                        handleNew={this.handleNewUser}
                    />}
                    <ToastContainer
                        draggablePercent={60}
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop
                        closeOnClick
                        rtl={false}
                        pauseOnVisibilityChange
                        draggable={false}
                        pauseOnHover
                    />
                    
                    <section className="row" id="statictopbar" style={{ padding: "15px 0px" , background : '#0190f7' }}>
                            <div className="col-sm-12" > </div>
                    </section>
                    <div className="col-sm-12 " >
                        <div className="container">
                            <div className="row  mt-3 p-4" >
                                <h4 className="w-100">
                                        <img src={logo} alt="" style={{ height :"60px"}} />
                                </h4> 
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 " >
                        <div className="row  mt-2 p-4" >
                            <div className="col-md-12 card-images text-center" style={{position : "relative"}}>
                                <h2 className='mt-3 pb-2 text-center' style={{fontSize : '30px'}}> <span className="color-dgrey">Click to Choose Your KlickEx</span> <span>Money Card<img  className='moneycard' src={highlitedtext} alt='aus' style={{width:"158px"}} /> </span> </h2>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 bglanding" >
                        <div className="row" >
                            <div className="col-lg-2 col-md-1  nopaddingleft pl-0" >
                                 <div className="d-flex flex-row-reverse" style={{ marginTop: 10 }}>
                                    <div className="col-auto justify-content-end mb-2 pl-0 ml-0 pr-0 mr-0">

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-5 col-sm-5 card-actions ml-3 pl-0 mr-0 pr-0" >
                                 <div className="d-flex flex-row-reverse" style={{ marginTop: 10 }}>
                                    <div className="col-auto justify-content-end mb-0 pl-0 ml-0 pr-0 mr-0">
                                        {/* <Link to='/RegisterCard' className='simplelink' style={{ marginLeft: '15px' , display: 'block' }}> */}
                                        {/* <Link to='/nz' className='simplelink' style={{ marginLeft: '15px' , display: 'block' }}> */}
                                         {/* <a href="https://cardholdertestenv01.oxygen-global.com/#/au" style={{ marginLeft: '15px' , display: 'block' }} >
                                            <img src={klickexcardAu} className='img-fluid' width={'90%'} />
                                         </a>  */}
                                         <span   onClick={()=>this.navigateURL('AU')} style={{ marginLeft: '15px' , display: 'block' , cursor : 'pointer' }} >
                                            <img src={klickexcardAu} className='img-fluid' width={'90%'} />
                                         </span> 
                                        {/* </Link> */}
                                        {/* <div className="mt-5 mb-3 flags text-center">
                                            <a href="https://cardholdertestenv01.oxygen-global.com/#/au" >
                                                <span className="badge-orange"> Australian Cardholder  </span>
                                            </a>
                                        </div> */}
                                         <div className="mt-5 mb-3 flags text-center" style={{  cursor : 'pointer' }}>
                                                <span className="badge-orange" onClick={()=>this.navigateURL('AU')}> Australian Cardholder  </span>
                                        </div>
                                        
                                        <div className="mt-2 mb-2 flags text-center">
                                            <img src={flagAu} /> 
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div className="col-lg-4 col-md-5 col-sm-5 card-actions ml-3 pl-0 mr-0 pr-0" >
                                <div className="d-flex flex-row-reverse" style={{ marginTop: 10 }}>
                                    <div className="col-auto justify-content-end mb-0 pl-0 ml-0 pr-0 mr-0">
                                        {/* <Link to='/RegisterCard' className='simplelink' style={{ marginLeft: '15px' , display: 'block' }}> */}
                                        {/* <Link to='/au' className='simplelink' style={{ marginLeft: '15px' , display: 'block' }}> */}
                                        {/* <a href="https://cardholdertestenv01.oxygen-global.com/#/nz" style={{ marginLeft: '15px' , display: 'block' }} >                                            
                                            <img src={klickexcardNz} className='img-fluid' width={'90%'} />
                                         </a> */}
                                        <span onClick={()=>this.navigateURL('NZ')} style={{ marginLeft: '15px' , display: 'block' , cursor : 'pointer' }} >                                            
                                            <img src={klickexcardNz} className='img-fluid' width={'90%'} />
                                        </span>
                                        {/* </Link> */}
                                        {/* <div className="mt-5 mb-3 flags text-center"> 
                                           <a href="https://cardholdertestenv01.oxygen-global.com/#/nz" >                                            
                                                <span className="badge-orange"> New Zealand Cardholder </span>
                                           </a>
                                        </div> */}
                                        <div className="mt-5 mb-3 flags text-center"> 
                                                <span className="badge-orange" onClick={()=>this.navigateURL('NZ')} style={{  cursor : 'pointer' }}> New Zealand Cardholder </span>
                                        </div>
                                        <div className="mt-2 mb-2 flags text-center"> 
                                           <img src={flagNz} /> 
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-1 col-md-2 pl-0 mr-0 pr-0" >
                                <div className="d-flex flex-row-reverse" style={{ marginTop: 10 }}>
                                    <div className="col-auto justify-content-end mb-2 pr-0 mr-0">
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-12 colorbgcyan " >
                        <div className="row mb-1 choosefrom pb-5">
                            <div className="container">
                                <div className="col-md-12" >
                                    <div className="row">
                                        <div className="col-md-1">
                                        </div>
                                        <div className="col-md-7 moneycardconent" >
                                            <h4 className='text-left'>While you are away, make shopping, spending, and accessing your money simple with KlickEx Money Card. Today, let's start by choosing either the Australian or New Zealand KlickEx Money Card.</h4>
                                        </div>
                                        <div className="col-md-4">
                                            <img src={wowcard} className='img-fluid' width={'95%'} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                           <div className="col-md-12 card-images text-center moneycarpunch" style={{position : "relative"}}>
                                <h2 className='mt-3 pb-2 text-center' style={{fontSize : '30px'}}><span className="color-dgrey"> With KlickEx </span> <span >Money Card<img  className='moneycard' src={highlitedtext} alt='aus' style={{width:"158px"}} /> </span> <span className="color-dgrey"> you can...</span> </h2>
                            </div>
                        </div>
                        <div className="container " >
                            
                        <div className="row pb-5 mt-5" >
                            <div className="col-md-12 " >
                                <section className="row" id="features" style={{ padding: "15px 0px" }}>
                                    <div className="col-md-4 col-sm-12 p-0 m-0 bg-white text-dark ">
                                        <div className="featuresgolden text-center wow zoomIn" data-wow-delay=".1s">
                                            <img src={activateImg} alt='activate' />
                                            <h4 className=" mt-3">SHOP NOW</h4>
                                            <h5 className=" mt-3">Shop, spend & Travel <br/> with your card</h5>
                                            <ul className="text-left">
                                            <li className="text-left" >Accessible Anywhere</li>
                                            <li className="text-left" >Worldwide Visa Acceptance - 24,000,000+ locations</li>
                                            <li className="text-left" >Secure Online Shopping</li>
                                            <li className="text-left" >Use in Australia / New Zealand  and Overseas</li>
                                            </ul>

                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-12  p-0 m-0  text-dark ">

                                        <div className="featuressky text-center wow zoomIn" data-wow-delay=".3s">
                                            <img src={manageImg} alt='manage' />

                                            <h4 className=" mt-3">MANAGE YOUR ACCOUNT</h4>
                                            <h5 className=" mt-3">Self manage your card <br/> easily</h5>
                                            <ul className="text-left">
                                            <li className="text-left" >Check Your Card Balance</li>
                                            <li className="text-left" >View Your Transaction History</li>
                                            <li className="text-left" >Set and/or Change Your PIN</li>
                                            <li className="text-left" >Update Your Personal Details</li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div className="col-md-4 col-sm-12 p-0 m-0 bg-white text-dark ">
                                        <div className=" featuresblack text-center wow zoomIn" data-wow-delay=".5s">
                                            <img src={customerImg} alt='Customer' />

                                            <h4 className=" mt-3">CUSTOMER SERVICE</h4>
                                            <h5 className=" mt-3">Get help when you <br/>need it</h5>
                                            <ul >
                                            <li className="text-left" >24-7 Online Access</li>
                                            <li className="text-left" >Email Customer Service </li>
                                            </ul>

                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div >
        );
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Landing));


// WEBPACK FOOTER //
// ./src/components/register/landing.jsx